export default "__VITE_ASSET__BAEod9Ct__"